module.exports = __webpack_public_path__ + "static/media/close.d1ef55b3.svg";